import { Box, Card, CardContent, CardHeader, LinearProgress, Typography } from "@mui/material";

export const StandardPanel = (params: {
    title?: string;
    action?: React.ReactNode | React.ReactNode[];
    loading: boolean;
    maxWidth?: number;
    height?: string;
    children?: React.ReactNode;
}) => (
    <Card
        elevation={3}
        sx={{
            // NOTE: must be "block" (not "inline-block"). As an inline-block the Card
            // is laid out on a text baseline; with overflow set it aligns by its bottom
            // edge and leaves a sub-pixel line-box gap that gets recomputed on every
            // re-render. The bids panel re-renders on every SignalR bid, which made the
            // whole layout creep (catalogue panel width changing + content drifting down
            // a few px per bid). Block layout removes the baseline/line-box involvement.
            display: "block",
            width: "100%",
            maxWidth: params.maxWidth || "100%",
            height: params.height,
            breakInside: "avoid",
            // Safe on a block box (block-level boxes aren't laid out on a text
            // baseline), and needed so height-constrained panels scroll internally.
            overflowY: "auto",
            mb: 0,
        }}
    >
        <CardHeader title={params.title} hea action={params.action} sx={{ px: { xs: 1, sm: 2 }, py: { xs: 0.5, sm: 1 } }} />
        {params.loading && <LinearProgress />}
        <CardContent sx={{ pt: { xs: 0.5, sm: 1 }, px: { xs: 1, sm: 2 }, pb: { xs: 1, sm: 2 } }}>{params.children}</CardContent>
    </Card>
);

export const DetailsRow = ({
    label,
    value,
}: {
    label: string;
    value: string | number | null | undefined;
}) => (
    <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={0}
        gap={0}
        sx={{ flexWrap: "wrap" }}
    >
        <Typography
            variant="body2"
            sx={{
                width: 150,
                fontWeight: 500,
                color: 'text.secondary',
                flexShrink: 0,
            }}
        >
            {label}
        </Typography>

        <Typography
            variant="body2"
            sx={{
                flex: 1,
                color: 'text.primary',
                wordBreak: 'break-word',
                textAlign: 'right',
            }}
        >
            {value || '-'}
        </Typography>
    </Box>
);

